import clsx from "clsx";
import React from "react";

type AttentionCardProps = {
  title: string;
  items: String | String[];
  isOdd: boolean;
  currentIndex: number;
};

const AttentionCard: React.FC<AttentionCardProps> = ({
  title,
  items,
  isOdd,
  currentIndex,
}) => {
  return (
    <article
      className={clsx(
        "flex flex-col gap-[1.142vw] justify-self-center relative z-10 max-lg:max-w-full max-lg:w-full w-[24vw] max-lg:py-[2.133vw] max-lg:gap-[4.26vw]",
        isOdd && "lg:items-end",
        currentIndex === 0 && "max-lg:mb-[6vw] max-lg:pt-[5vw]",
        currentIndex === 1 && "max-lg:mb-[27.4vw] ma",
        currentIndex === 2 && "max-lg:mb-[11.5vw] max-lg:-mt-1"
      )}
    >
      <h3
        className={clsx(
          "text-black z-10 whitespace-pre-line relative font-luxora-regular text-24 max-lg:text-[5.33vw] leading-[1.1] text-black max-lg:max-w-[60vw] max-w-[22.857vw] text-left",
          isOdd && "lg:text-right"
        )}
      >
        {title}
      </h3>
      {Array.isArray(items) ? (
        <div
          className={clsx(
            "flex flex-wrap gap-[0.571vw] max-lg:gap-[1vw]",
            isOdd && "lg:justify-end"
          )}
        >
          {items.map((item, index) => (
            <div
              key={index}
              className="text-[1.142vw] max-lg:text-[3.6vw] max-lg:py-[2.13vw] max-lg:px-[3.2vw] rounded-[2vw] max-lg:rounded-[7.46vw] w-fit  text-[#00000099] leading-[1.1] custom-shadow bg-[#F3F3F8] linear-gradient font-normal px-[0.857vw] py-[0.571vw]"
            >
              {item}
            </div>
          ))}
        </div>
      ) : (
        <p
          className={clsx(
            "text-[1.142vw] max-lg:text-[3.73vw] text-[#00000099] leading-[1.1] max-lg:max-w-full max-w-[23.285vw]",
            isOdd && "lg:text-right"
          )}
        >
          {items}
        </p>
      )}
    </article>
  );
};

export default AttentionCard;
